import { z } from "zod";
import { SPEAKER_TYPES, SEGMENT_TYPES } from "@/isomorphic/constants/call-data-consts";

/**
 * Transcript Segment Schema (Isomorphic - camelCase)
 * Represents fine-grained transcript segments aligned with questions
 */
export const TranscriptSegmentSchema = z.object({
  id: z.string().uuid(),
  callAttemptId: z.string().uuid(),
  recordingId: z.string().uuid().nullable(),

  // Timing
  startMs: z.number().int().nullable(),
  endMs: z.number().int().nullable(),

  // Contenu
  speaker: z.enum(SPEAKER_TYPES),
  participantId: z.string().uuid().nullable(),
  text: z.string(),

  // Qualité
  confidence: z.number().min(0).max(1).nullable(),

  // Lien avec la phase (optionnel)
  relatedQuestionId: z.string().nullable(),
  segmentType: z.enum(SEGMENT_TYPES).nullable(),

  // Métadonnées
  metadata: z.record(z.string(), z.unknown()).default({}),

  createdAt: z.date(),
  updatedAt: z.date(),
});

export type TranscriptSegment = z.infer<typeof TranscriptSegmentSchema>;
